module.exports = __webpack_public_path__ + "static/media/beloved_header.b72f8cf2.png";